import './index.css'

import { Link } from 'react-router-dom'

const ServiceItemCard = ({title,short_description,image,slug}) => {
  return (
    <Link to={`${slug}`} className='service-item'>
        <div className='service-item-image mb-3'>
            <img src={image} alt="" />
            <p>{short_description}</p>
        </div>
        <h5>{title}</h5>
    </Link>
  )
}

export default ServiceItemCard